import script from "./VFullRadioGroup.vue?vue&type=script&lang=ts&setup=true"
export * from "./VFullRadioGroup.vue?vue&type=script&lang=ts&setup=true"

import "./VFullRadioGroup.vue?vue&type=style&index=0&id=cb537bb2&lang=sass"

const __exports__ = script;

export default __exports__